import React from "react";
import { Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  FabricStyleInventorySearchCriteria,
  PageListBean,
  RestFabricStyleInventoryListBeanRequest,
} from "../ds/ds.js";
import {
  InputTextbox,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { InventoryService } from "../services/InventoryService.js";
import CustomTable from "../gui_components/CustomTable.js";
class FabricStyleCurrentInventory extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "FabricStyle Current Inventory Inquiry",
      isShowCriteriaView: true,
      isShowPopup: false,
      inquiryDataList: [],
      criteria: new FabricStyleInventorySearchCriteria(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      error_list: [],
      progressLoadingText: "",
      isShowProgressBarPopup: "",
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (
      this.props.fabricStyleCode !== "" &&
      this.props.fabricStyleCode !== undefined
    ) {
      let temp_Criteria = this.state.criteria;
      temp_Criteria.fabricStyleCode = this.props.fabricStyleCode;
      this.setState({
        criteria: temp_Criteria,
        isShowCriteriaView: false,
      });
      this.loadPage();
    }
  }
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ errorList: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = new PageListBean();
    pageList.pageSize = 50;
    let request = new RestFabricStyleInventoryListBeanRequest();
    request.searchCriteria = criteria;
    request.pageInput = pageList;
    this.loadItemCurrentInventory(request);
  };
  loadItemCurrentInventory = (request) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Fetching",
    });
    InventoryService.getFabricStyleInventoryData(
      request,
      this.loadResponse,
      this.errorCallBack
    );
  };
  loadResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStyleInventoryDataPageList != null
    ) {
      let inquiryDataList = [];
      if (
        !isEmptyArray(
          response.data.fabricStyleInventoryDataPageList
            .fabricStyleInventoryDatas
        )
      ) {
        inquiryDataList =
          response.data.fabricStyleInventoryDataPageList
            .fabricStyleInventoryDatas;
        // this.setState({
        //   isShowPDFButton: true,
        //   isShowExcelButton: true,
        // });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: inquiryDataList,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  closeAlertProgressBarModalCallBack = (isShowPopup) => {
    this.setState({
      isShowProgressBarPopup: isShowPopup,
    });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item " : "FabricStyle",
          "fabricStyleCode",
          true
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
   
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "totalOnHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
   
  
    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <BaseInquiryToolBar
          pageTitle={
            this.state.is3PL
              ? "Item Current Inventory Inquiry"
              : "FabricStyle Current Inventory Inquiry"
          }
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <Row>
          <Col sm="1">
            <FormLabel>CompanyCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox value={this.companyCode} disabled={true} />
          </Col>
          <Col sm="1">
            {this.state.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox value={this.props.fabricStyleCode} disabled={true} />
          </Col>
        </Row>
         <div className="mt-3">
          <CustomTable
            data={inquiryDataList}
            columns={this.inquiryColumns()}
          />
        </div>
      </div>
    );
  }
}
function FabricStyleCurrentInventoryInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <FabricStyleCurrentInventory {...props} name="" /> <br />
    </div>
  );
}

export default FabricStyleCurrentInventoryInquiry;
